/**
 * Defines an option to display with PesFormSelect component
 */
export type PesFormSelectOption = {
  label: string;
  value: string | number;
  postIcon?: string;
  svgIcon?: string;
};
